import { render, staticRenderFns } from "./BigOne.vue?vue&type=template&id=7f8b46b0"
import script from "./BigOne.vue?vue&type=script&lang=js"
export * from "./BigOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports